import globalAxios from 'axios';
import { B as BaseAPI, D as DUMMY_BASE_URL, s as setBearerAuthToObject, b as setSearchParams, c as serializeDataIfNeeded, t as toPathString, o as operationServerMap, d as createRequestFunction, e as BASE_PATH } from '../common-BuhUSHAi.js';

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * BookingReportsApi - axios parameter creator
 * @export
 */
const BookingReportsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {BookingReportSearch} [BookingReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookingAnalytics: async (BookingReportSearch, options = {}) => {
            const localVarPath = `/v1/BookingReports/GetBookingAnalytics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(BookingReportSearch, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {BookingReportSearch} [BookingReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookingKpis: async (BookingReportSearch, options = {}) => {
            const localVarPath = `/v1/BookingReports/GetBookingKpis`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(BookingReportSearch, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {BookingReportSearch} [BookingReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookingOccupancy: async (BookingReportSearch, options = {}) => {
            const localVarPath = `/v1/BookingReports/GetBookingOccupancy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(BookingReportSearch, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {BookingReportSearch} [BookingReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookingsByService: async (BookingReportSearch, options = {}) => {
            const localVarPath = `/v1/BookingReports/GetBookingsByService`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(BookingReportSearch, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {BookingReportSearch} [BookingReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookingsByStore: async (BookingReportSearch, options = {}) => {
            const localVarPath = `/v1/BookingReports/GetBookingsByStore`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(BookingReportSearch, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {BookingReportSearch} [BookingReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookingsTrend: async (BookingReportSearch, options = {}) => {
            const localVarPath = `/v1/BookingReports/GetBookingsTrend`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(BookingReportSearch, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * BookingReportsApi - functional programming interface
 * @export
 */
const BookingReportsApiFp = function (configuration) {
    const localVarAxiosParamCreator = BookingReportsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {BookingReportSearch} [BookingReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBookingAnalytics(BookingReportSearch, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBookingAnalytics(BookingReportSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingReportsApi.getBookingAnalytics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {BookingReportSearch} [BookingReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBookingKpis(BookingReportSearch, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBookingKpis(BookingReportSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingReportsApi.getBookingKpis']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {BookingReportSearch} [BookingReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBookingOccupancy(BookingReportSearch, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBookingOccupancy(BookingReportSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingReportsApi.getBookingOccupancy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {BookingReportSearch} [BookingReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBookingsByService(BookingReportSearch, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBookingsByService(BookingReportSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingReportsApi.getBookingsByService']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {BookingReportSearch} [BookingReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBookingsByStore(BookingReportSearch, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBookingsByStore(BookingReportSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingReportsApi.getBookingsByStore']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {BookingReportSearch} [BookingReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBookingsTrend(BookingReportSearch, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBookingsTrend(BookingReportSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingReportsApi.getBookingsTrend']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * BookingReportsApi - factory interface
 * @export
 */
const BookingReportsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = BookingReportsApiFp(configuration);
    return {
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {BookingReportSearch} [BookingReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookingAnalytics(BookingReportSearch, options) {
            return localVarFp.getBookingAnalytics(BookingReportSearch, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {BookingReportSearch} [BookingReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookingKpis(BookingReportSearch, options) {
            return localVarFp.getBookingKpis(BookingReportSearch, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {BookingReportSearch} [BookingReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookingOccupancy(BookingReportSearch, options) {
            return localVarFp.getBookingOccupancy(BookingReportSearch, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {BookingReportSearch} [BookingReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookingsByService(BookingReportSearch, options) {
            return localVarFp.getBookingsByService(BookingReportSearch, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {BookingReportSearch} [BookingReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookingsByStore(BookingReportSearch, options) {
            return localVarFp.getBookingsByStore(BookingReportSearch, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {BookingReportSearch} [BookingReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookingsTrend(BookingReportSearch, options) {
            return localVarFp.getBookingsTrend(BookingReportSearch, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * BookingReportsApi - object-oriented interface
 * @export
 * @class BookingReportsApi
 * @extends {BaseAPI}
 */
class BookingReportsApi extends BaseAPI {
    /**
     *
     * @summary  (Auth policies: Bookings)
     * @param {BookingReportSearch} [BookingReportSearch]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingReportsApi
     */
    getBookingAnalytics(BookingReportSearch, options) {
        return BookingReportsApiFp(this.configuration).getBookingAnalytics(BookingReportSearch, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth policies: Bookings)
     * @param {BookingReportSearch} [BookingReportSearch]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingReportsApi
     */
    getBookingKpis(BookingReportSearch, options) {
        return BookingReportsApiFp(this.configuration).getBookingKpis(BookingReportSearch, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth policies: Bookings)
     * @param {BookingReportSearch} [BookingReportSearch]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingReportsApi
     */
    getBookingOccupancy(BookingReportSearch, options) {
        return BookingReportsApiFp(this.configuration).getBookingOccupancy(BookingReportSearch, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth policies: Bookings)
     * @param {BookingReportSearch} [BookingReportSearch]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingReportsApi
     */
    getBookingsByService(BookingReportSearch, options) {
        return BookingReportsApiFp(this.configuration).getBookingsByService(BookingReportSearch, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth policies: Bookings)
     * @param {BookingReportSearch} [BookingReportSearch]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingReportsApi
     */
    getBookingsByStore(BookingReportSearch, options) {
        return BookingReportsApiFp(this.configuration).getBookingsByStore(BookingReportSearch, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth policies: Bookings)
     * @param {BookingReportSearch} [BookingReportSearch]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingReportsApi
     */
    getBookingsTrend(BookingReportSearch, options) {
        return BookingReportsApiFp(this.configuration).getBookingsTrend(BookingReportSearch, options).then((request) => request(this.axios, this.basePath));
    }
}

export { BookingReportsApi, BookingReportsApiAxiosParamCreator, BookingReportsApiFactory, BookingReportsApiFp };
//# sourceMappingURL=booking-reports-api.js.map
